import React from 'react';
import { FaSearch } from 'react-icons/fa';

const PinterestSearchBox = ({ searchChange, placeholder, searchField }) => {
  return (
    <div style={{
      position: 'relative',
      width: '100%',
      maxWidth: '800px',
      margin: '0 auto'
    }}>
      <div style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
      }}>
        <FaSearch 
          style={{
            position: 'absolute',
            left: '16px',
            color: '#767676',
            fontSize: '16px',
            zIndex: 1
          }}
        />
        <input
          type='search'
          //placeholder='Search for food & drink, fashion, etc.'
          value={searchField || ''}
          placeholder={placeholder}
          onChange={searchChange}
          style={{
            width: '100%',
            padding: '12px 16px 12px 48px',
            fontSize: '16px',
            border: 'none',
            borderRadius: '24px',
            backgroundColor: '#efefef',
            outline: 'none',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
            transition: 'all 0.2s ease',
            boxShadow: 'none'
          }}
          onFocus={(e) => {
            e.target.style.backgroundColor = '#e1e1e1';
            e.target.style.boxShadow = '0 0 0 4px rgba(0, 0, 0, 0.08)';
          }}
          onBlur={(e) => {
            e.target.style.backgroundColor = '#efefef';
            e.target.style.boxShadow = 'none';
          }}
        />
      </div>
    </div>
  );
};

export default PinterestSearchBox;